import * as types from "./breadcrumb.actionsType";

export default {
  setCurrentBreadcrumb: name => ({
    type: types.SET_CURRENT_BREADCRUMB,
    payload: name
  }),
  setStateBreadcrumb: currentBreadcrumb => ({
    type: types.SET_BREADCRUMB,
    payload: {
      currentBreadcrumb
    }
  })
};
